import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import AppProvider from './providers/AppProvider';
import ErrorBoundary from './components/ErrorBoundary';
import { router } from './routes/pmsRoutes';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <AppProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </AppProvider>
  </ErrorBoundary>
);
